module.exports = __webpack_public_path__ + "static/media/team-6@2x.ad295f8e.jpg";